<template>
  <div class="folder-artricles-section">
  <a-row v-if="!skeletonLoader && articles.length >= 1 && isLoggedInUser && articleType !== 'suggested' && collapseType === 'folders' && !activeFolder?.isOrg  && addDocumentPermission.includes(activeFolder?.permission)" :gutter="22">
    <button class="folder-artricles-section__add-pdf-btn" @click="openAddDocumentModal()">
      <i class="icon icon-add_plus"></i>
    </button>
    <!-- <button class="folder-artricles-section__add-pdf-btn" @click="openAddDocumentModal()">
      <i class="icon icon-add_plus"></i>
    </button> -->
  </a-row>
  <a-row v-if="!skeletonLoader && articles.length == 0" :gutter="22" >
    <button v-if="isLoggedInUser && isCategoryOrFolderSelected && collapseType === 'folders' && !activeFolder?.isOrg && articleType !== 'suggested' && addDocumentPermission.includes(activeFolder?.permission)" @click="openAddDocumentModal()" class="folder-artricles-section__add-content-btn"><i class="icon icon-add_plus"></i> Add content</button>
    <p class="folder-artricles-section__message" v-else>No articles found</p>
  </a-row>
  <a-row v-else-if="articles.length > 0" :gutter="[15, 15]">
    <a-col
      v-for="data in articles"
      :key="data.id"
      :xs="24"
      :sm="24"
      :md="12"
      :lg="12"
      :xl="xl"
    >
      <article-card
        v-if="isShowArticles(data)"
        :title="data.article.title"
        :author-name="data.article.authors"
        :url="data.article.article_url?.url ?? ''"
        :sourceLogo="data.article.logo"
        :source="data.article.article_url?.source ?? ''"
        :image="data.article.image"
        :text="data.article.description"
        :id="data.article.id"
        :date="data.article.pub_date"
        :ratings="data.article.rating"
        :aggregatedRating="data.article.aggregated_rating"
        :userReaction="data.article.user_reaction"
        :totalArticleReactions="data.article.article_reactions"
        :userReactionRepresentation="data.article.users_reaction_representation"
        :isInsightArticle="true"
        :showShareButton="true"
        :showSaveBtn="false"
        :showUnsaveBtn="false"
        :articleContentId="data.id"
        :articleEllipsis="collapseType === 'folders' && articleType !== 'suggested' ?  true  : false"
        :showDltBtnSaveArchive="false"
        :folderId="folderId"
        :articleId="data.id"
        @articleOpen="openArticle(data)"
      >
      </article-card>
      <template v-else>
        <PdfCard
          :pdfFileName="data.title"
          :pdfUrl="data.file_content || data.file || data?.link || data?.link_content"
          :id="data.id"
          :archiveFolderId="folderId" 
          :isArchiveContent="collapseType !== 'folders' ? true : false"
          :isDocumentLink="data?.link || data?.link_content ? true : false"
          :authorName="data?.user.full_name"
        />
      </template>
    </a-col>
  </a-row>
  <a-row v-if="skeletonLoader" :gutter="15" class="skeleton-loader-wrapper">
    <a-col :xs="24" :sm="12" :md="12" :lg="12" :xl="xl" v-for="index in 3" :key="index">
      <ArticleCardSkeleton/>
    </a-col>
  </a-row>
  </div>
  <UploadDocumentsModal 
   :visible="visibleUploadDocumentModal"
   :folderId="folderId"
   :modalTitle="'Document'"
   :isArchiveContentModal="collapseType === 'folders' ? false : true"
   @closeModal="closeAddDocumentModal()"
  />
</template>

<script>
import ArticleCardSkeleton from "../BaseComponents/ArticleCardSkeleton.vue"
import ArticleCard from "../BaseComponents/ArticleCard.vue";
import UploadDocumentsModal from "./UploadDocumentModal.vue";
import PdfCard from "./PDFCard.vue";
import folderMixin from '../../mixins/folders.mixnin.js';
import { mapGetters } from "vuex/dist/vuex.cjs.js";

export default {
  components: {
    ArticleCard,
    ArticleCardSkeleton,
    UploadDocumentsModal,
    PdfCard,
  },
  data() {
    return {
      visibleUploadDocumentModal: false,
      xl: 12,
      addDocumentPermission: ['admin', 'editor']
    }
  },
  props:{
    articleType:{
      required:true
    },
    collaborateToggle: {
      type: Boolean,
      default:()=>true
    },
    isTransitioning: {
      type: Boolean,
      default:()=>false
    },
    collapseType:{
      type: String,
      default: () => ('folders')
    },
    archiveFolderId:{
      type: String,
      default: ()=>('')
    }
  },
  watch: {
    collaborateToggle: {
      handler() {
        this.updateXl();
      },
      immediate: true
    },
    isTransitioning: {
      handler() {
        this.updateXl();
      },
      immediate: true
    },
    collapseType: {
      handler(val) {
        if(val == 'archive') {
          this.xl = 8;
        }
      },
      immediate: true
    }
  },
  mixins: [folderMixin],
  computed: {
    ...mapGetters({
      fetchContentLoader: 'archive/fetchContentLoader',
      activeFolder: 'folders/activeFolder'
    }),
    isLoggedInUser() {
      return this.$store.getters["profile/isLoggedinUser"];
    },
    skeletonLoader() {
      if (this.collapseType === 'folders'){
        if (this.articleType === 'suggested'){
          return this.$store.getters["folders/folderSuggestedArticleSkeleton"]
        }else{
          return this.$store.getters["folders/getFolderArticlesContentLoader"] 
        }
      }else{
        return this.fetchContentLoader
      }
    },
    folderArticles() {
      if (this.articleType === 'articles')
        return this.$store.getters["folders/getFolderArticleContent"]
      else if (this.articleType === 'suggested')
        return this.$store.getters["folders/getFolderSuggestedArticleContent"].map(article=>({
          article:{
            ...article,
            authors: article?.authors[0],
            description: article?.description[0],
            id: article?.id[0],
            image: article?.image[0],
            logo: article?.logo[0],
            pub_date: article?.pub_date[0],
            title: article?.title[0]
          }, 
          content_type:'articles'
        }))
      else
        return []
    },
    archiveArticles () {
      if (this.articleType === 'articles')
        return this.$store.getters["archive/folderContentList"]
      else if (this.articleType === 'suggested')
        return this.$store.getters["archive/archiveSuggestedFolderContentList"].map(article=>({
          article:{
            ...article,
            authors: article?.authors[0],
            description: article?.description[0],
            id: article?.id[0],
            image: article?.image[0],
            logo: article?.logo[0],
            pub_date: article?.pub_date[0],
            title: article?.title[0]
          }, 
          content_type:'articles'
        }))
      else
        return []
    },
    articles(){
      // return this.collapseType === 'folders' ? this.folderArticles : this.archiveArticles
      return this.folderArticles
    },
    folderId() {  
      return this.collapseType !== 'folders' && this.archiveFolderId ? this.archiveFolderId : this.$route.params.id
    },
    
    isCategoryOrFolderSelected(){
      return this.folderId ? true  : false
    }
  },
  methods: {
    openAddDocumentModal() {
      this.visibleUploadDocumentModal = true;
    },
    closeAddDocumentModal(){
      this.visibleUploadDocumentModal = false;
    },
    openArticle(data) {
      this.createActivity(data.id, 'folder_content', 'open');
    },
    updateXl() {
      if (this.collaborateToggle && this.isTransitioning) {
        this.xl = 12;
      } else if (!this.collaborateToggle && !this.isTransitioning){
        this.xl = 8;
      }
    },
    isShowArticles(data){
      return data.content === 'article' || data.content_type === 'articles'
    }
  }
};
</script>

<style lang="scss">
.folder-artricles-section {
  &__add-pdf-btn {
    background-color: $color-primary;
    height: 4.2rem;
    width: 4.2rem;
    border: none;
    outline: none;
    border-radius: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: auto;
    margin-right: 1.5rem;
    margin-bottom: 2rem;
    .icon {
      color: $color-white;
      font-size: 1.6rem;
    }
  }
  &__add-content-btn {
    display: flex;
    align-items: center;
    background-color: transparent;
    font-size: 1.6rem;
    font-family: $font-primary;
    height: fit-content;
    line-height: normal;
    padding: 0;
    border: none;
    outline: none;
    color: $color-black;
    margin: 5rem auto 0;
    cursor: pointer;
    .icon {
      font-size: 1.4rem;
      margin-right: 1rem;
      margin-bottom: 0.1rem;
    }
  }
  &__message {
    font-size: 1.6rem;
    font-family: $font-primary;
    margin-bottom: 0;
    line-height: normal;
    color: $color-black;
    text-align: center;
    margin-top: 4rem;
    width: 100%;
    @include respond(tab-port) {
      font-size: 1.8rem;
    }
  }
  .skeleton-loader-wrapper {
    margin-top: 15px;
  }
}
</style>
